import React, { useEffect, useState } from "react";
import { isFunction } from "lodash";
import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import PageContentLoader from "./PageContentLoader";
import { objectToQueryString } from "../../utils/helper";
import { Box, CircularProgress, Typography } from "@mui/material";

/**
 *
 * @param {*} param0
 * @returns {JSX.Element}
 * @component
 */
const PaymentForm = ({
  amount,
  clientSecret,
  successParams,
  onPaymentProcess,
  onCloseDialog,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [errorMessage, setErrorMessage] = useState("");
  const [processing, setProcessing] = useState(false);
  const [processMessage, setProcessMessage] = useState("");
  const [isStripeReady, setIsStripeReady] = useState(false);

  useEffect(() => {
    if (isFunction(onPaymentProcess)) {
      onPaymentProcess(processing);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [processing]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    log.debug(
      `${window.location.origin}/payment-complete${objectToQueryString(successParams)}`,
    );

    if (elements === null || stripe === null || processing) {
      return;
    }

    // Trigger form validation and wallet collection
    const { error: submitError } = await elements.submit();
    if (submitError?.message) {
      // Show error to customer
      setErrorMessage(submitError.message);
      return;
    }

    setProcessMessage(
      "Your payment is being processed, please wait while we check",
    );
    setProcessing(true);

    const { error } = await stripe.confirmPayment({
      //`Elements` instance that was used to create the Payment Element
      elements,
      clientSecret,
      confirmParams: {
        return_url: `${window.location.origin}/payment-complete${objectToQueryString(successParams)}`,
      },
    });

    if (error) {
      // This point will only be reached if there is an immediate error when
      // confirming the payment. Show error to your customer (for example, payment
      // details incomplete)
      setErrorMessage(error.message);
      setProcessing(false);
      setProcessMessage("");
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
      log.debug("Payment succeeded");

      // If onCloseDialog function exists (from StripePaymentModal), close the dialog
      if (isFunction(onCloseDialog)) {
        onCloseDialog();
      }
    }
  };

  const handleReady = () => setIsStripeReady(true);

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="text-center">
          <h3>Pay Amount: ${amount}.00</h3>
        </div>

        {!isStripeReady && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              my: 4,
            }}
          >
            <CircularProgress size={40} sx={{ mb: 2 }} />
            <Typography variant="body2" color="text.secondary">
              Loading payment form...
            </Typography>
          </Box>
        )}

        <PaymentElement onReady={handleReady} />

        <div className="text-center">
          {isStripeReady && (
            <button
              type="submit"
              disabled={!stripe || !elements}
              className="default-btn membr-btn w-100"
            >
              Pay
            </button>
          )}
        </div>
        {/* Show error message to customers */}
        {/* {errorMessage && <Alert severity="error">{errorMessage}</Alert>} */}
        {errorMessage && (
          <div className="error-payment" severity="error">
            {errorMessage}
          </div>
        )}
      </form>
      <div>{processing && <PageContentLoader message={processMessage} />}</div>
    </>
  );
};

export default PaymentForm;
